export const support = {
  seo: {
    title: 'Contact & Support | Bistroo',
    description: "Contactez l'équipe support Bistroo par téléphone, WhatsApp ou e-mail. Nous vous aidons rapidement.",
  },
  hero: {
    heading: {
      1: 'Notre',
      2: 'service client',
      3: 'est là pour vous',
    },
    description: {
      1: 'Bienvenue dans notre service client',
      2: 'Afin de pouvoir vous servir au mieux, nous vous demandons de faire un choix parmi les options disponibles ci-dessous. Nous nous assurons ainsi que vous accédez directement aux bonnes informations ou aux bonnes options de contact.',
    },
  },
  cards: {
    helpcenter: {
      description: 'Toutes les informations dont vous avez besoin',
      title: 'Centre d\'aide & FAQ',
      text: 'Visitez notre centre d\'aide pour des conseils et des réponses à toutes vos questions. Ou lisez notre page FAQ avec les questions les plus fréquemment posées.',
      actions: {
        helpcenter: 'Visiter le centre d\'aide',
        faq: 'Questions fréquemment posées',
      },
    },
    demo: {
      description: 'Équipe de support',
      title: 'Une démo',
      text: 'Une démo avec notre équipe ?',
      action: {
        title: 'Demander une démo',
        button: 'Demander',
      },
    },
    address: {
      description: 'Bistroo',
      title: 'Notre adresse',
      text: 'Vous pouvez nous trouver à l\'adresse ci-dessous',
      address: {
        mail: 'Adresse postale :',
        visit: 'Adresse de visite (sur rendez-vous)',
      },
    },
    contact: {
      description: 'Nous contacter',
      title: 'Contact',
      text: 'Vous souhaitez nous contacter directement ? C\'est possible !',
    },
    partners: {
      description: 'Devenir partenaire',
      title: 'Partenaires',
      text: 'Faites croître votre activité et devenez partenaire de Bistroo !',
      action: {
        title: 'Devenir partenaire',
        button: 'En savoir plus',
      },
    },
  },
}
